import { postPaymentEvergreen } from "@api/index";
import { styled } from "@linaria/react";
import Button from "@pages/EverGreen/Components/Button";
import {
  trackOnFormStartOrSuccess,
  trackOnLoad,
} from "@pages/EverGreen/Helpers/analyticsHelper";
import { interbankSRSPayment } from "@pages/EverGreen/Helpers/helpers";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { updatePaymentRef } from "@redux/slices/EVER_GREEN/step4Slice";
import { ROUTE_PATH } from "@static/route-paths";
import { EverGreenStyle } from "@utils/Style/everGreen";
import { LoadingScreen } from "@utils/helpers";
import { IEvergreenPaymentPayload } from "@utils/interfaces";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

function ConfirmButton() {
  const formData = useAvivaSelector((state) => state.everGreenStep4);
  const customerId = useAvivaSelector(
    (state) => state.everGreenStep2.myInfo.customerId
  );
  const transactionId = useAvivaSelector(
    (state) => state.everGreenStep1.transactionId || ""
  );
  const arcCode = useAvivaSelector(state=>state.everGreenStep3.arcCode)
  const [disable, setDisabled] = useState(true);
  const dispatch = useAvivaDispatch();
  const history = useHistory();

  const trackingCodeJson = {
    ecid:"",pid:"",arc:arcCode,formType:""}
  const onClickHandler = useCallback(async () => {
    if (formData.paymentMethod === "interbank") {
      history.push(ROUTE_PATH.EVER_GREEN_FAST_PAYMENT);
      return;
    }
    if (formData.paymentMethod === "now") {
      history.push(ROUTE_PATH.EVER_GREEN_PAY_NOW);
      return;
    }
    interbankSRSPayment(formData, history, customerId, transactionId, trackingCodeJson);
  }, [formData]);

  useEffect(() => {
    if (formData.paymentMethod === "interbank") {
      // const {isPayingSelf, name, nric, reason,relationship} = formData.interbankFastForm
      // if((isPayingSelf === "NO" && name && nric && nric.length === 9 && relationship)|| (isPayingSelf === "YES")){
      //   if(relationship ==="Others" && !reason.trim() ){
      //     setDisabled(true)
      //     return;
      //   }
      //     setDisabled(false)
      // }
      // else{
      //     setDisabled(true)
      // }
      setDisabled(false);
    } else if (formData.paymentMethod === "srs") {
      const { accountNum, operator } = formData.srsForm;
      if (validateSrs(accountNum, operator.id)) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    } else if (formData.paymentMethod === "now") {
      setDisabled(false);
    }
  }, [formData]);

  const validateSrs = useCallback(function (accNo: string, bankId: string) {
    if (!bankId) return false;
    switch (bankId) {
      // DBS
      case "1": {
        if (accNo.length === 14 && accNo.endsWith("223")) {
          return true;
        }
        return false;
      }
      // OCBC
      case "2": {
        if (accNo.length === 12) {
          return true;
        }
        return false;
      }
      case "3": {
        if (accNo.length === 9) {
          return true;
        }
        return false;
      }
    }
  }, []);

  return (
    <>
      <BtnContainer>
        <Button
          label={
            formData.paymentMethod === "srs"
              ? "Confirm payment mode"
              : ["now", "interbank"].includes(formData.paymentMethod)
              ? "Proceed to pay"
              : "Submit application"
          }
          disabled={disable}
          width="308px"
          margin={"64px auto"}
          onClick={onClickHandler}
        />
        {/* {(formData.paymentMethod === "interbank" || formData.paymentMethod === "fast") && (
          <span style={{ margin: "auto" }}>
            Payment instructions will be shown on the next page.
          </span>
        )} */}
      </BtnContainer>
    </>
  );
}

export default ConfirmButton;

const BtnContainer = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  button {
    margin-bottom: 16px;
  }
  & > span {
    font-size: 12px;
    font-weight: 500;
    color: ${EverGreenStyle.colors.grey[1400]};
    line-height: 19.2px;
  }
`;
